import IconFlower from '$lib/icons/IconFlower.svelte?raw';

export const disabledButtonClasses = [
	'!text-gray-500',
	'!bg-gray-300',
	'!border-gray-300',
	'!hover:bg-gray-300',
	'!hover:border-gray-300',
	'!hover:text-gray-600',
];

export function setLoadingState(node: HTMLElement, isLoading: boolean) {
	const originalInnerHtml = node.innerHTML;
	const originalClasses = node.className + ' ';
	const originalWidth = node.offsetWidth + 'px';
	const originalHeight = node.offsetHeight + 'px';
	const originalStyle = node.getAttribute('style') ?? '';

	function setNodeState(node: HTMLElement, isLoading: boolean) {
		if (isLoading) {
			node.setAttribute('disabled', 'true');
			node.setAttribute('style', `${originalStyle} width: ${originalWidth}; height: ${originalHeight}`);
			node.classList.add('!cursor-wait', ...disabledButtonClasses);
			node.innerHTML = `<div class="w-full h-full flex justify-center items-center animate-spin">${IconFlower}</div>`;
		} else {
			if (originalInnerHtml) {
				node.innerHTML = originalInnerHtml;
				node.className = originalClasses;
				node.setAttribute('style', originalStyle);
				node.removeAttribute('disabled');
			}
		}
	}
	setNodeState(node, isLoading);

	return {
		update(newIsLoading: boolean) {
			setNodeState(node, newIsLoading);
		},
		destroy() {
			// nothing to do
		},
	};
}
